var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToastCaution(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.266 21.4981H2.73301C2.37575 21.4981 2.04563 21.3075 1.867 20.9981C1.68837 20.6887 1.68838 20.3075 1.86701 19.9981L11.133 3.99811C11.3118 3.68923 11.6416 3.49902 11.9985 3.49902C12.3554 3.49902 12.6852 3.68923 12.864 3.99811L22.13 19.9981C22.3085 20.3074 22.3086 20.6883 22.1303 20.9977C21.9519 21.307 21.6221 21.4977 21.265 21.4981H21.266ZM12 6.49811L4.46901 19.4981H19.533L12 6.49811ZM12.995 15.4991H10.995V10.4981H12.995V15.4991Z",
    fill: "#FFBC03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16.5001H13V18.5001H11V16.5001Z",
    fill: "#FFBC03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastCaution);
export default __webpack_public_path__ + "static/media/toast-caution.6df44df830ee60fa599b3340994a9f66.svg";
export { ForwardRef as ReactComponent };